import { render } from "./unread-messages.vue?vue&type=template&id=fda21056"
import script from "./unread-messages.vue?vue&type=script&lang=js"
export * from "./unread-messages.vue?vue&type=script&lang=js"

import "./unread-messages.vue?vue&type=style&index=0&id=fda21056&lang=css"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__